<template>
  <div class="view company" v-if="company">
    <section class="banner">
      <div class="banner-background">
        <img v-if="!isMobile" src="@/assets/cast_map_banner.svg">
      </div>
    </section>
    <section class="company-container">
      <div class="wrapper">
        <div class="company-info">
          <div class="company-logo">
            <img :src="company.image" :alt="company.name">
          </div>
          <div class="company-contact">
            <a v-if="company.email" :href="`mailto:${company.email}`">
              <i class="far fa-envelope"></i>
            </a>
            <a v-if="company.website" :href="(company.website.startsWith('http') ? '' : 'http://') + company.website" target="_blank">
              <i class="fas fa-home"></i>
            </a>
          </div>
          <div class="info-box">
            <div class="info-name">Address</div>
            <div class="info-value">
              <div class="address">{{company.address}}</div>
              <div class="city">{{company.city}}</div>
              <div class="country">{{company.country}}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="info-name">Year of creation</div>
            <div class="info-value">{{company.creation_year}}</div>
          </div>
        </div>
        <div class="company-content">
          <h1 class="company-name">{{company.name}}</h1>
          <div class="company-types">
            <span class="company-type" v-for="type in company.types" :key="`type-${company.id}-${type}`" :style="{color: colors[type]}">{{type}}</span>
          </div>
          <div class="company-info-mobile">
            <div class="info-box">
              <div class="info-name">Address</div>
              <div class="info-value">
                <div class="address">{{company.address}}</div>
                <div class="city">{{company.city}}</div>
                <div class="country">{{company.country}}</div>
              </div>
            </div>
            <div class="info-box">
              <div class="info-name">Year of creation</div>
              <div class="info-value">{{company.creation_year}}</div>
            </div>
          </div>
          <div class="company-description" v-html="company.description"></div>
        </div>
      </div>
      <div class="company-description mobile" v-html="company.description"></div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'company',
  computed: {
    ...mapGetters({
      'db': 'getDb',
      isMobile: 'getMobile'
    }),
    companyId() {
      return this.$route.params.id
    }
  },
  data() {
    return {
      colors: {
        'Incubator': '#0D988C',
        'Investor Network': '#8ABB2A',
        'Cluster': '#880F50',
        'Chamber of Commerce': '#D4177C',
        'Accelerator': '#FFD400',
        'Development Centre': '#F77E0B',
        'Association': '#E77323',
        'Foundation': '#BCBCCB',
        'BIC': '#00A1ED',
        'Non-profit': '#343434'
      },
      company: null
    }
  },
  watch: {
    companyId(id) {
      this.getCompany(id)
    }
  },
  methods: {
    getCompany(id) {
      if(this.companyRef) this.companyRef()
      if(id) {
        this.companyRef = this.db().collection('companies').doc(id).onSnapshot(company => {
          this.company = company.exists ? company.data() : null
          this.$store.commit('setPageLoading', false)
        })
      }
    }
  },
  mounted: function() {
    this.getCompany(this.companyId)
  },
  beforeDestroy: function() {
    if(this.companyRef) this.companyRef()
  }
}
</script>

<style scoped>
.company {
  /* background: url(../assets/cast_partners_banner.jpg) no-repeat top center/1920px auto; */
  padding-top: 372px;
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
}

.banner .banner-background svg,
.banner .banner-background img {
  display: block;
  width: 100%;
  height: auto;
}

.banner .banner-bubbles {
  position: absolute;
  top: 225px;
  right: 198px;
  width: 838px;
  height: 505px;
}

.page-title {
  position: relative;
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 202px;
}

.page-title h1 {
  position: relative;
  font: bold 3.21em/1 'Butler';
  padding-top: 12px;
}

.page-title p {
  position: relative;
  margin-left: 196px;
  width: 800px;
}

.page-title svg {
  position: absolute;
  top: -70px;
  left: 90px;
}

.page-title p:before {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: -136px;
  bottom: 0;
  width: 60px;
  height: 1px;
  margin: auto;
  background: #fff;
}

.banner .picture-alt {
  margin-top: 10px;
  text-align: center;
  color: #BCBCCB;
  text-transform: uppercase;
  letter-spacing: .58em;
  font-size: .72em;
}

.company-container .wrapper {
  display: flex;
  width: 1104px;
}

.company-info {
  width: 256px;
  flex-shrink: 0;
  font-size: 1.43em;
}

.company-content {
  flex-grow: 1;
  padding: 72px 24px 0;
  margin-left: 48px;
}

.company-name {
  font: bold 3.2em/1 'Butler';
  margin-bottom: 16px;
}

.company-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 256px;
  background: url(../assets/cast_company_logo.svg) no-repeat center/contain;
}

.company-logo img {
  display: block;
  width: 80%;
}

.company .company-type {
  display: inline-block;
  border: 1px solid;
  padding: 4px 8px;
  border-radius: 14px;
  margin-right: 8px;
  line-height: 1;
}

.company-contact {
  text-align: center;
}

.company-contact a {
  display: inline-flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid rgba(0, 162, 237, 0.5);
  margin: 0 8px;
  font-size: 20px;
}

.info-box {
  margin-top: 32px;
}

.info-box .info-name {
  color: #00a2ed;
  border-bottom: 1px solid rgba(0, 162, 237, 0.5);
  margin-bottom: 8px;
}

.company-description {
  font-size: 1.43em;
  line-height: 2;
  margin-top: 64px;
}

.mobile,
.company-info-mobile {
  display: none;
}

@media screen and (max-width: 1024px) {
  .page-title {
    color: #343434;
  }
  .page-title {
    display: block;
    padding: 0;
    text-align: center;
  }
  .page-title h1 {
    color:#880F50;
  }
  .page-title p {
    width: 420px;
    max-width: 100%;
    margin: auto;
  }
  .page-title p:before {
    position: relative;
    display: block;
    left: auto;
    margin: 8px auto;
    background: #880F50;
  }
  .banner .picture-alt {
    display: none;
  }
  .company {
    padding-top: 240px;
  }
  .company-info {
    font-size: 18px;
  }
  .company-description {
    font-size: 18px;
    line-height: 1.77;
    margin-top: 48px;
  }
  .company-content {
    margin-left: 24px;
  }
}

@media screen and (max-width: 900px) {
  .company-info .info-box,
  .company-content .company-description {
    display: none;
  }
  .mobile {
    display: block;
  }
  .company-info-mobile {
    display: flex;
  }
  .company-info-mobile .info-box {
    flex-grow: 1;
    padding-right: 16px;
  }
  .company-content {
    padding-left: 0;
    padding-right: 0;
  }
  .company-description {
    padding: 0 24px;
  }
  .company-name {
    font-size: 32px;
  }
}

@media screen and (max-width: 760px) {
  .company-info {
    width: 160px;
  }
  .company-logo {
    height: 160px
  }
  .company-content {
    padding-top: 24px;
  }
}

@media screen and (max-width: 680px) {
  .company {
    padding-top: 172px;
  }
}

@media screen and (max-width: 600px) {
  .company-info-mobile {
    display: block;
  }
  .company-info-mobile .info-box {
    width: 100%;
    padding: 0;
  }
}

@media screen and (max-width: 520px) {
  .company-content {
    position: relative;
    padding-top: 48px;
    padding-bottom: 72px;
    margin-left: 0;
  }
  .company-info {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
  }
  .company-logo {
    width: 160px;
  }
  .company-name {
    padding-left: 176px;
    font-size: 24px;
  }
  .company-types {
    padding-left: 176px;
    font-size: 10px;
  }
  .company-info-mobile {
    margin-top: 64px;
  }
  .company-contact {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

@media screen and (max-width: 480px) {
  .company-logo {
    width: 96px;
    height: 96px;
  }
  .company-content {
    padding-top: 24px;
  }
  .company-name {
    padding-left: 112px;
  }
  .company-types {
    padding-left: 112px;
  }
  .company-info-mobile {
    margin-top: 24px;
  }
  .company-description {
    font-size: 16px;
  }
}
</style>
